import { useDispatch } from "react-redux";
import { cartActions } from "../../store/cart-slice";
import { useSelector } from "react-redux";
import useCheckStock from "../Hooks/useCheckStock";
import addToCart from "../../resources/images/app/cart.png";
import add from "../../resources/images/app/add.png";
import remove from "../../resources/images/app/remove.png";
import recycleBin from "../../resources/images/app/delete.png";
import { uiActions } from "../../store/Ui-slice";
import { MdDelete } from "react-icons/md";
import { BiCartAdd } from "react-icons/bi";
import { basics } from "../../basics";
// TODO: this component will render a lot of variable exp: cartItemPlusOneItem,existingCartItemPlusOneItem,.. you should decrease it.
const AddAndRemoveItemButton = (props: any) => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state: any) => state.cart.items.items);
  const LoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const { id } = props.data;
  const checkStockHook = useCheckStock(id);
  const cartItemPlusOneItem = cartItems?.find(
    (item: any) => item.product.id === id
  );
  const existingCartItemPlusOneItem = cartItemPlusOneItem ? true : false;
  const addItemHandler = () => {
    if (LoggedIn) {
      dispatch(
        cartActions.addItemToCart({
          quantity: 1,
          ...props.data,
        })
        );
      } else {
      dispatch(uiActions.toggleModal());
    }
  };
  
  const removeItemHandler = () => {
    dispatch(cartActions.removeItemFromCart(id));
  };

  const addButtonShapeStyles =
    props.variant === "circle"
      ? "w-11 h-11 rounded-full p-0"
      : props.large
      ? "w-full min-w-[120px] h-11 rounded-xl p-1"
      : "w-full min-w-[120px] h-9 rounded-xl p-1";

  return (
    <div>
      {/* {LoggedIn && <div>asdada</div> } */}
      {!existingCartItemPlusOneItem && (
        <div
          onClick={addItemHandler}
          className={`flex justify-center items-center gap-2 ${addButtonShapeStyles} text-white ${props.styles} font-medium ${props.large ? "text-base" : "text-sm"} text-center cursor-pointer transition`}
        >
          {/* <img src={addToCart} className="w-6 h-6 " alt="" /> */}
          <BiCartAdd className={props.large ? "w-5 h-5" : "w-6 h-6"}/>
          {props.showLabel && <span>{basics.addToCart}</span>}
        </div>
      )}
      {existingCartItemPlusOneItem && (
        <div

          className={`flex justify-between items-center min-w-[120px] ${props.large ? "h-11" : "h-9"} text-white px-2 rounded-xl ${props.styles} transition`}
        >
          {cartItemPlusOneItem.quantity === 1 ? (
            <div  onClick={removeItemHandler}>
             <MdDelete className="w-6 h-6  cursor-pointer "/>
              
            </div>
          ) : (
            <div
              onClick={removeItemHandler}
              className=""
              // className="bg-emerald-300 hover:bg-emerald-600 text-gray-800 font-bold mx-1 p-4 rounded-full"
            >
              <img src={remove} className="filter brightness-0 invert w-6 h-6 cursor-pointer" alt="" />
            </div>
          )}
          <div className="w-7 h-7 m-1 flex justify-center items-center font-bold">{cartItemPlusOneItem.quantity}</div>
          {checkStockHook > 0 ? (
            <div
              onClick={addItemHandler}
              // disabled={stockCount === 0}
              // className="bg-emerald-300 hover:bg-emerald-600 text-gray-800 font-bold mx-1 p-4 rounded-full"
            >
              <img src={add} className="filter brightness-0 invert w-6 h-6 cursor-pointer " alt="" />
              
            </div>
          ) : (
            <div
            // disabled={stockCount === 0}
            // className=" p-2 text-gray-800 font-bold rounded-full"
            >
              <img src={add} className="filter brightness-0 invert w-6 h-6" alt="" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddAndRemoveItemButton;
